import store from '@/store/index.js'

export const publicPages = [
    'default',
    'slash_default',
    'undergraduate_explore',
    'master_explore',
    'phd_explore',
    'undergraduate_announcement',
    'undergraduate_announcement_tcas',
    'undergraduate_announcement_tcas_detail',
    'undergraduate_announcement_inter',
    'undergraduate_announcement_con',
    'undergraduate_announcement_premium',
    'undergraduate_announcement_special',
    'graduate_announcement',
    'graduate_announcement_master',
    'graduate_announcement_doctor',
    'graduate_announcement_inter',
    'graduate_announcement_future_innovators',
    'graduate_announcement_file_download',
    'create_password',
];
export const studentPages = [
    'registered_program_list',
    'info_example',

    'applicant_info_general',
    'applicant_info_school',
    'applicant_info_university',
    'applicant_info_medicine',
    'applicant_info_eng_inter',
    'applicant_info_constraints',

    'applicant_info_additional_undergraduate',
    'questionnaire',

    'application_kbank_slip',
    'application_scb_slip',
    'assertion_kbank_slip',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
];
export const registrarOfficerPages = [
    'applicant_info_undergraduate',
    'applicant_info_graduate',
    'form_undergraduate_medicine',
    'config_year',
    'config_faculty_bank_account',
    'config_round',
    'config_project',
    'config_project_group',
    'config_curriculum',
    'config_curriculum_constraint',
    'config_master_reg_curriculum',
    'config_faculty_officer_main',
    'number_of_applicants_report',
    'number_of_applicants_by_order_report',
    'number_of_applicants_passed_report',
    'applicants_report_list',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
    'manual_for_executor',
    'config_curriculum_gat_pat',
    'move_applicant',
    'gen_student_id',
    'not_paid_tuition_fee',
    'search_user',
]; 
export const graduateRegistrarOfficerPages = [
    'applicant_info_undergraduate',
    'applicant_info_graduate',
    'form_undergraduate_medicine',
    'config_year',
    'config_faculty_bank_account',
    'config_round',
    'config_project',
    'config_curriculum',
    'config_curriculum_constraint',
    'config_master_reg_curriculum',
    'config_faculty_officer_main',
    'number_of_applicants_report',
    'number_of_applicants_by_order_report',
    'number_of_applicants_passed_report',
    'applicants_report_list',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
    'manual_for_executor',
    'move_applicant',
    'gen_student_id',
    'search_user',
];
export const no_structure = [
    'application_kbank_slip',
    'application_scb_slip',
    'assertion_kbank_slip',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
]

export const adminPages = [
    'applicant_info_undergraduate',
    'applicant_info_graduate',
    'form_undergraduate_medicine',
    'config_year',
    'config_faculty_bank_account',
    'config_round',
    'config_project',
    'config_project_group',
    'config_curriculum',
    'config_curriculum_constraint',
    'config_master_reg_curriculum',
    'number_of_applicants_report',
    'number_of_applicants_by_order_report',
    'number_of_applicants_passed_report',
    'applicants_report_list',
    'select_data_to_show',
    'config_faculty_officer_main',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
    'manual_for_executor',
    'config_curriculum_gat_pat',
    'move_applicant',
    'gen_student_id',
    'not_paid_tuition_fee',
    'search_user',
]

export const facultyOfficerPages = [
    'number_of_applicants_report',
    'number_of_applicants_by_order_report',
    'number_of_applicants_passed_report',
    'applicants_report_list',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
    'manual_for_executor',
]

export const teacherPages = [
    'number_of_applicants_report',
    'number_of_applicants_by_order_report',
    'number_of_applicants_passed_report',
    'applicants_report_list',
    'application_pdf_undergraduate',
    'application_pdf_graduate',
    'manual_for_executor',
] 

export function check_permission(route_name) {
    // Public
    if (publicPages.includes(route_name)) {
        return true;
    }

    // Student
    else if (
        studentPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.admission.status
    ) {
        return true;
    }

    // Register Officer
    else if (
        registrarOfficerPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.delegated_officer.status &&
        store.state.auth.user.delegated_officer.privilege == 40
    ) {
        return true;
    }

    // Register Officer Graduate
    else if (
        graduateRegistrarOfficerPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.delegated_officer.status &&
        store.state.auth.user.delegated_officer.privilege == 45
    ) {
        return true;
    }

    // Admin
    else if (
        adminPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.delegated_officer.status &&
        store.state.auth.user.delegated_officer.privilege == 91
    ) {
        return true;
    }

    // Faculty Officer
    else if (
        facultyOfficerPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.delegated_officer.status &&
        store.state.auth.user.delegated_officer.privilege == 10
    ) {
        return true;
    }

    // Teacher
    else if (
        teacherPages.includes(route_name) &&
        store.state.auth.user &&
        store.state.auth.user.delegated_officer.status &&
        store.state.auth.user.delegated_officer.privilege == 60
    ) {
        return true;
    }

    else {
        return false;
    }
}
export function is_student() {
    if (store.state.auth.user &&
        store.state.auth.user.admission.status)
        return true;
    return false;
}